import { render, staticRenderFns } from "./CtrlTipoSolicitacaoPage.vue?vue&type=template&id=84ffc2d8"
import script from "./CtrlTipoSolicitacaoPage.vue?vue&type=script&lang=js"
export * from "./CtrlTipoSolicitacaoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports